export enum PreviewStatuses {
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  NOT_SUPPORTED = "NOT_SUPPORTED",
  DELETED = "DELETED",
}
